import { UseQueryOptions, useInfiniteQuery, useQuery } from '@tanstack/react-query';
import axios, { AxiosResponse } from 'axios';
import { HavePaginationEntity } from 'src/entities/HavePagination.entity';
import { ProductEntity as Entity } from 'src/entities/ProductEntity';

const requestPathBase = '/api/v4/master/products';
export const queryKey = 'useProductsRequest';

const getResources = async (page: number, sortCondition: string, searchCondition: string, per?: number) => {
  const requestParams = [
    `page=${page + 1}`,
    sortCondition ? `sort_condition=${sortCondition}` : '',
    searchCondition ? `${searchCondition}` : '',
    per ? `per=${per}` : '',
  ].filter((maybe) => maybe).join('&');

  const requestPath = [
    requestPathBase,
    requestParams,
  ].join('?');

  const response: AxiosResponse<HavePaginationEntity<Entity>> = await axios.get<HavePaginationEntity<Entity>>(requestPath);

  return response.data;
};

export const useProductsRequest = (
  page: number,
  sortCondition: string,
  searchCondition: string,
  per?: number,
  options?: Omit<UseQueryOptions<HavePaginationEntity<Entity>>, 'queryKey' | 'queryFn'>
) => useQuery(
  [queryKey, { page, sortCondition, searchCondition, per }],
  () => getResources(page, sortCondition, searchCondition, per),
  options
);

export const useInfiniteProductsRequest = (sortCondition: string, searchCondition: string, enabled: boolean, per?: number) => useInfiniteQuery({
  queryKey: [queryKey, { sortCondition, searchCondition, per }],
  queryFn: ({ pageParam = 0 }: { pageParam?: number }) => getResources(pageParam, sortCondition, searchCondition, per),
  getNextPageParam: (lastPage, allPages) => (allPages.length < lastPage.totalPageCount ? allPages.length : undefined),
  staleTime: Infinity,
  enabled,
});
